// extracted by mini-css-extract-plugin
module.exports = {"nav":"menu-footer-module--nav--1AlG6","current":"menu-footer-module--current--3s-CT"};